const localizers = {
  'Alerts.noAlerts.txt': () => `Δεν έχουν οριστεί ειδοποιήσεις για αυτήν την αναφορά.`,
  'BirdImage.image.txt': () => `Εικόνα`,
  'ComboBox.clearFilter.txt': () => `Απαλοιφή φίλτρου`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (Δεν υπάρχουν δεδομένα)`,
  'ContextMenu.selectAll.txt': () => `Επιλογή όλων`,
  'ContextMenu.clearSelection.txt': () => `Απαλοιφή επιλογής`,
  'ContextMenu.exportImage.txt': () => `Εξαγωγή ως εικόνας`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: Αύξουσα`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: Φθίνουσα`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: Προσθήκη αύξουσας ταξινόμησης`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: Προσθήκη φθίνουσας ταξινόμησης`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Κατάργηση ${role} από ταξινόμηση`,
  'ContextMenu.removeSortLevel.txt': () => `Κατάργηση επιπέδου ταξινόμησης`,
  'ContextMenu.sort.txt': () => `Ταξινόμηση`,
  'ContextMenu.selectShortestPath.txt': () => `Επιλογή συντομότερης διαδρομής`,
  'ContextMenu.explain.txt': () => `Επεξήγηση δεδομένων`,
  'ContextMenu.explainRole.txt': ({role}) => `Επεξήγηση ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Διαχείριση στηλών`,
  'ContextMenu.includeMissingValues.txt': () => `Συμπερίληψη τιμών που λείπουν`,
  'DrillableTooltip.drill.txt': () => `ΑΝΑΛΥΣΗ`,
  'DrillableTooltip.tooltip.txt': () => `ΕΠΕΞΗΓΗΣΗ ΕΡΓΑΛΕΙΟΥ`,
  'DrillableTooltip.links.txt': () => `ΣΥΝΔΕΣΕΙΣ`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Σύνδεση σελίδας προς ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Σύνδεση αναφοράς προς ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Εξωτερική σύνδεση προς ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Μη διαθέσιμο`,
  'Breadcrumb.all.fmt': ({label}) => `Όλα τα ${label}`,
  'BrowserCheck.title.txt': () => `Έλεγχος WebGL`,
  'BrowserCheck.msg.txt': () => `Το WebGL είτε είναι απενεργοποιημένο είτε δεν υποστηρίζεται από το πρόγραμμα περιήγησης.   \nΚάντε κλικ στο κουμπί OK για να προβάλετε την αναφορά σε κλασική προβολή.`,
  'EmailUtil.subject.multiple.txt': () => `Αναφορές για ανασκόπηση`,
  'EmailUtil.tooLongEmail.txt': () => `Έγινε υπέρβαση του ορίου μήκους email. Επιλέξτε λιγότερες αναφορές για αποστολή μέσω email.`,
  'HiddenSectionDialog.close.txt': () => `Κλείσιμο`,
  'HiddenSectionDialog.export.txt': () => `Εξαγωγή ως PDF`,
  'InfoPanel.information.txt': () => `Πληροφορίες`,
  'InfoPanel.comments.txt': () => `Σχόλια`,
  'InfoPanel.alerts.txt': () => `Ειδοποιήσεις`,
  'IncomingFilters.promptbars.txt': () => `Γραμμές προτροπών`,
  'Information.title.txt': () => `Τίτλος`,
  'Information.name.txt': () => `Όνομα:`,
  'Information.description.txt': () => `Περιγραφή:`,
  'Information.displayRules.txt': () => `Κανόνες εμφάνισης:`,
  'Information.graphLevel.txt': () => `Επίπεδο γραφήματος`,
  'Information.reportLevel.txt': () => `Επίπεδο αναφοράς`,
  'Information.legend.txt': () => `Υπόμνημα`,
  'Information.incomingFilters.txt': () => `Φίλτρα εισερχομένων:`,
  'Information.noIncomingFilters.txt': () => `Χωρίς φίλτρα εισερχομένων`,
  'Information.dataSourceFilters.txt': () => `Φίλτρα προέλευσης δεδομένων:`,
  'Information.interactiveFilters.txt': () => `Αλληλεπιδραστικά φίλτρα:`,
  'MobileContainer.mobileBIMessage.txt': () => `Αποκτήστε πρόσβαση στις αναφορές SAS από την κινητή σας συσκευή.`,
  'ObjectTypes.report.txt': () => `Αναφορά`,
  'ObjectTypes.Report.BI.txt': () => `Αναφορά SAS (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored process report`,
  'ObjectTypes.StoredProcess.txt': () => `Αποθηκευμένη διεργασία`,
  'MissingValues.label.txt': () => `(τιμές που λείπουν)`,
  'PromptContainer.apply.txt': () => `OK`,
  'PromptContainer.cancel.txt': () => `Άκυρο`,
  'PromptContainer.close.txt': () => `Κλείσιμο`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Η τιμή πρέπει να είναι ένας αριθμός μεταξύ του ${min} και του ${max}, συμπεριλαμβανομένων.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Καθορίστε μια έγκυρη αριθμητική τιμή.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Η τιμή δεν είναι έγκυρη για τα εκχωρημένα δεδομένα`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Πληκτρολογήστε: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Πληκτρολογήστε: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Πληκτρολογήστε ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} - ${max}`,
  'Slider.missingValues.txt': () => `Τιμές που λείπουν`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Πίσω`,
  'ReportContainer.reportCorrupted.txt': () => `ΚΑΤΕΣΤΡΑΜΜΕΝΗ ΑΝΑΦΟΡΑ`,
  'ReportContainer.themeLoadFailed.txt': () => `Η φόρτωση του θέματος αναφοράς απέτυχε.`,
  'ReportContainer.restoreButton.tip.txt': () => `Επαναφορά αναφοράς`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Έγινε επαναφορά αναφοράς`,
  'ReportContainer.renderError.txt': () => `Παρουσιάστηκε σφάλμα. Δεν ήταν δυνατή η εμφάνιση της αναφοράς.`,
  'ReportContainer.component.renderError.txt': () => `Παρουσιάστηκε σφάλμα. Δεν ήταν δυνατή απόδοση του στοιχείου.`,
  'ReportContentPage.open.txt': () => `Άνοιγμα...`,
  'ReportContentPage.refreshReport.txt': () => `Ανανέωση αναφοράς`,
  'ReportContentPage.editReport.txt': () => `Επεξεργασία αναφοράς`,
  'ReportContentPage.print.txt': () => `Εκτύπωση...`,
  'ReportContentPage.email.txt': () => `Email...`,
  'ReportContentPage.export.txt': () => `Εξαγωγή στο Excel...`,
  'ReportContentPage.reportProperties.txt': () => `Ιδιότητες αναφοράς`,
  'ReportContentPage.shareReport.txt': () => `Κοινοποίηση αναφοράς`,
  'ReportContentPage.enableOverlays.txt': () => `Ενεργοποίηση επικαλύψεων αντικειμένων`,
  'ReportContentPage.disableOverlays.txt': () => `Απενεργοποίηση επικαλύψεων αντικειμένων`,
  'ReportContentPage.link.txt': () => `Σύνδεση...`,
  'ReportContentPage.settings.txt': () => `Ρυθμίσεις...`,
  'ReportContentPage.editPlayback.txt': () => `Επεξεργασία αναπαραγωγής`,
  'ReportContentPage.playReport.txt': () => `Αναπαραγωγή αναφοράς`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Εμφάνιση φίλτρων προτροπών`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Απόκρυψη φίλτρων προτροπών`,
  'ReportContentPage.reportFilters.txt': () => `Επίπεδο αναφοράς`,
  'ReportContentPage.pageFilters.txt': () => `Επίπεδο σελίδας`,
  'ReportContentPage.refreshRequired.txt': () => `Απαιτείται ανανέωση της αναφοράς`,
  'ReportContentPage.infoButton.tip.txt': () => `Πίνακας πληροφοριών`,
  'ReportContentPage.backButton.tip.txt': () => `Προβολή όλων των αναφορών`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Περισσότερες επιλογές`,
  'ReportContentPage.itemGroupName.txt': () => `Αναφορές`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Μεγιστοποίηση αναφοράς`,
  'ReportContentPage.closeButton.txt': () => `Κλείσιμο αναφοράς`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Έγινε μεγιστοποίηση αναφοράς`,
  'ReportContentPage.resetReportState.txt': () => `Επαναφορά προεπιλεγμένης κατάστασης αναφοράς`,
  'ReportContentPage.summary.txt': () => `Εμφάνιση σύνοψης`,
  'ReportManagerPage.objectMenu.open.txt': () => `Άνοιγμα`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Επεξεργασία`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Σύνοψη`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Ιδιότητες`,
  'ReportManagerPage.objectMenu.email.txt': () => `Email...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Εκτύπωση`,
  'ReportManagerPage.browseReportsButton.txt': () => `Περιήγηση αναφορών`,
  'ReportManagerPage.newReportButton.txt': () => `Νέα αναφορά`,
  'ReportManagerPage.emptyView.message.txt': () => `Δεν βρέθηκαν αναφορές.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Περιήγηση για αναφορές`,
  'ReportManagerPage.tableView.name.txt': () => `Όνομα`,
  'ReportManagerPage.tableView.author.txt': () => `Συντάκτης`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Τελευταία τροποποίηση`,
  'ReportManagerPage.openButton.tip.txt': () => `Άνοιγμα αναφοράς`,
  'ReportManagerPage.emailButton.tip.txt': () => `Αποστολή αναφοράς μέσω email`,
  'ReportManagerPage.printButton.tip.txt': () => `Εκτύπωση αναφοράς σε PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Ιδιότητες αναφοράς`,
  'ReportObject.multipleReferences.error.txt': () => `Τα αντικείμενα αναφοράς δεν μπορούν να χρησιμοποιηθούν σε πολλαπλά περιβάλλοντα.`,
  'ReportObject.notFound.error.txt': () => `Δεν ήταν δυνατή η εύρεση του ονόματος αντικειμένου στην καθορισμένη αναφορά.`,
  'ReportObject.invalidPage.error.txt': () => `Η καθορισμένη σελίδα δεν είναι έγκυρη.`,
  'ReportPropertiesDialog.open.txt': () => `Άνοιγμα`,
  'ReportPropertiesDialog.close.txt': () => `Κλείσιμο`,
  'ReportPropertiesDialog.name.txt': () => `Όνομα:`,
  'ReportPropertiesDialog.description.txt': () => `Περιγραφή:`,
  'ReportPropertiesDialog.keywords.txt': () => `Λέξεις-κλειδιά:`,
  'ReportPropertiesDialog.type.txt': () => `Τύπος:`,
  'ReportPropertiesDialog.location.txt': () => `Τοποθεσία:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Δημιουργήθηκε από:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Ημερομηνία δημιουργίας:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Τροποποιήθηκε από:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Ημερομηνία τροποποίησης:`,
  'ReportSections.newPageButton.txt': () => `Νέα σελίδα`,
  'ReportSections.closeTab.tooltip.txt': () => `Διαγραφή σελίδας`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `Μενού ${label}`,
  'ReportSummaryDialog.title.txt': () => `Σύνοψη`,
  'ReportSummaryDialog.open.txt': () => `Άνοιγμα`,
  'ReportSummaryDialog.cancel.txt': () => `Άκυρο`,
  'ReportSummaryDialog.close.txt': () => `Κλείσιμο`,
  'ReportSummaryDialog.noSummary.txt': () => `Δεν υπάρχει διαθέσιμη σύνοψη.`,
  'ReportTileBody.modifiedBy.txt': () => `Τροποποιήθηκε από:`,
  'ReportTileBody.lastModified.txt': () => `Τελευταία τροποποίηση:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Report Viewer`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Ανανέωση αναφοράς`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Αυτόματη ανανέωση αναφοράς`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Ελέγξτε για ενημερώσεις μετά από τον ακόλουθο αριθμό λεπτών:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Ειδοποιήσεις`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Επιλέξτε τις προεπιλεγμένες ειδοποιήσεις:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `Αποστολή μηνυμάτων e-mail`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `Αποστολή μηνυμάτων SMS`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Προεπιλογή διαχειριστή`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Θέματα`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Αντικατάσταση του θέματος αναφοράς και χρήση του θέματος αναφοράς SAS High Contrast`,
  'ViewerBusyDialog.openReport.txt': () => `Άνοιγμα αναφοράς...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Προετοιμασία εξαγωγής...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Προετοιμασία για εκτύπωση...`,
  'PDFGeneration.printingReport.txt': () => `Δημιουργία αναφοράς PDF. Όταν είναι έτοιμη, θα πραγματοποιηθεί λήψη.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} στις ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Επιλογή ενέργειας`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `Έχετε φτάσει στο κατώτερο επίπεδο της ιεραρχίας.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Έχετε φτάσει στο κατώτερο επίπεδο όλων των ιεραρχιών.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Εξειδίκευση σε ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Στιγμιότυπο ${a0} ${a1} σε ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Αποθήκευση εικόνας`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Εκτύπωση αντικειμένου...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Κοινοποίηση αντικειμένου...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Περισσότερα`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Μενού αντικειμένων για ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Προβολή με SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `Ζουμ`,
  'ZoomControl.button.zoomin.txt': () => `Μεγέθυνση`,
  'ZoomControl.button.zoomout.txt': () => `Σμίκρυνση`,
  'ZoomControl.button.display.txt': () => `Έλεγχοι μεγέθυνσης`,
  'ZoomControl.button.reset.txt': () => `Επαναφορά μεγέθυνσης`,
  'ExpandControl.button.expand.txt': () => `Μεγιστοποίηση προβολής`,
  'ExpandControl.button.restore.txt': () => `Επαναφορά προβολής`,
  'ExpandControl.button.expand.tip.txt': () => `Μεγιστοποίηση`,
  'ExpandControl.button.restore.tip.txt': () => `Επαναφορά`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Δεν είναι δυνατή η εκτέλεση συνδέσεων σελίδας ενώ αυτό το αντικείμενο είναι μεγιστοποιημένο.`,
  'DragModeControl.button.pan.tip.txt': () => `Μετατόπιση`,
  'DragModeControl.button.circular.tip.txt': () => `Κυκλική επιλογή`,
  'DragModeControl.button.freeform.tip.txt': () => `Επιλογή ελεύθερης μορφής`,
  'DragModeControl.button.rectangular.tip.txt': () => `Ορθογώνια επιλογή`,
  'DragModeControl.button.zoom.tip.txt': () => `Ζουμ σε ορθογώνιο`,
  'ReportXMLDialog.title.txt': () => `Αναφορά XML`,
  'ReportXMLDialog.closeButton.txt': () => `Κλείσιμο`,
  'ReportXMLDialog.copyButton.txt': () => `Αντιγραφή στο πρόχειρο`,
  'ReportXMLDialog.error.txt': () => `Σφάλμα κατά τη φόρτωση της αναφοράς XML`,
  'ErrorDialog.error.txt': () => `Παρουσιάστηκε σφάλμα. Επικοινωνήστε με τον διαχειριστή του συστήματος.`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - Report Viewer`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Άνοιγμα αναφοράς`,
  'OpenReportDialog.reports.txt': () => `Αναφορές:`,
  'OpenReportDialog.cancel.txt': () => `Άκυρο`,
  'OpenReportDialog.ok.txt': () => `OK`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `Ενημερώθηκαν${count} αντικείμενα`,
  'AriaLive.oneObjectUpdated.txt': () => `Ενημερώθηκε 1 αντικείμενο`,
  'AriaLive.reportOpened.txt': () => `Η αναφορά άνοιξε`,
  'AriaLive.reportClosed.txt': () => `Η αναφορά έκλεισε`,
  'ExportData.generating.txt': () => `Δημιουργία εξαγωγής. Όταν είναι έτοιμη, θα πραγματοποιηθεί λήψη.`,
  'ExportData.warning.txt': () => `Σφάλμα δημιουργίας δεδομένων`,
  'ExportData.nodata.txt': () => `Δεν υπάρχουν δεδομένα για εξαγωγή`,
  'ExportData.exportData.txt': () => `Εξαγωγή δεδομένων...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Αποθήκευση`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Άκυρο`,
  'PlaybackAnimationDialog.playButton.txt': () => `Αναπαραγωγή αναφοράς`,
  'PlaybackAnimationDialog.title.txt': () => `Επεξεργασία αναπαραγωγής`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Μονάδα μετάβασης:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Σελίδα`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Αντικείμενο`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Δευτερόλεπτα ανά μονάδα:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Εμφάνιση μεγιστοποιημένων αντικειμένων:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Εμφάνιση μόνο καμβά:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Εμφάνιση χρονομέτρησης:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Εμφάνιση ελέγχου πλοήγησης με κλικ ή άγγιγμα:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Προηγούμενη σελίδα`,
  'PlaybackNavigationControls.nextPage.txt': () => `Επόμενη σελίδα`,
  'PlaybackNavigationControls.previousObject.txt': () => `Προηγούμενο αντικείμενο`,
  'PlaybackNavigationControls.nextObject.txt': () => `Επόμενο αντικείμενο`,
  'TransportConnection.generateReportTimeout.txt': () => `Η φόρτωση της αναφοράς διαρκεί πάρα πολλή ώρα. Θέλετε να συνεχίσετε;`,
  'TransportConnection.openReport.txt': () => `Άνοιγμα αναφοράς`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Η καθορισμένη αναφορά στην ακόλουθη τοποθεσία δεν υπάρχει: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `Ανάπτυξη ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `Σύμπτυξη ${label}`,
  'GraphElementDecorator.overview.txt': () => `Επισκόπηση`,
  'GraphElementDecorator.layers.txt': () => `Απόκρυψη ή εμφάνιση επιπέδων`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Απόκρυψη επισκόπησης`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Εμφάνιση επισκόπησης`,
  'TitleInfoButton.tooltip.txt': () => `Πληροφορίες`,
  'SectionSelectionBar.noSelections.txt': () => `Δεν υπάρχουν επιλογές`,
  'SectionSelectionBar.title.txt': () => `Φίλτρα:`,
  'CheckboxList.selectAll.txt': () => `Επιλογή όλων`,
  'CheckboxList.clearSelection.txt': () => `Απαλοιφή επιλογής`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Απαλοιφή επιλογής (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Επεξήγηση ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Προετοιμασία επεξήγησης...`,
  'ExplanationInfoDialog.cancel.txt': () => `Άκυρο`,
  'ExplanationInfoDialog.close.txt': () => `Κλείσιμο`,
  'PromptHeader.emptyReport.txt': () => `Σύρετε ένα στοιχείο δεδομένων ή ελέγχου εδώ για να δημιουργήσετε μια ερώτηση αναφοράς.`,
  'PromptHeader.emptyPage.txt': () => `Σύρετε ένα στοιχείο δεδομένων ή ελέγχου εδώ για να δημιουργήσετε μια ερώτηση σελίδας.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Σύμπτυξη περιοχής ελέγχων σελίδας`,
  'PromptHeader.expandPageControlArea.txt': () => `Ανάπτυξη περιοχής ελέγχων σελίδας`,
  'PromptHeader.collapseReportControlArea.txt': () => `Σύμπτυξη περιοχής ελέγχων αναφοράς`,
  'PromptHeader.expandReportControlArea.txt': () => `Ανάπτυξη περιοχής ελέγχων αναφοράς`,
  'PromptHeader.collapseControlArea.txt': () => `Σύμπτυξη περιοχής ελέγχων`,
  'PromptHeader.expandControlArea.txt': () => `Ανάπτυξη περιοχής ελέγχων`,
  'PromptHeader.reportControlArea.txt': () => `Περιοχή ελέγχων αναφοράς`,
  'PromptHeader.allControlAreas.txt': () => `Όλες οι περιοχές ελέγχων`,
  'PromptHeader.pageControlArea.txt': () => `Περιοχή ελέγχων σελίδας`,
  'ZeroState.editMode.txt': () => `Σύρετε ένα πρότυπο, στοιχεία δεδομένων ή αντικείμενα εδώ.`,
  'ZeroState.viewMode.txt': () => `Δεν υπάρχει περιεχόμενο για εμφάνιση`,
  'ObjectStatus.assignData.txt': () => `Εκχώρηση δεδομένων`,
  'ObjectStatus.selectImage.txt': () => `Επιλογή εικόνας`,
  'ObjectStatus.selectJob.txt': () => `Επιλογή εργασίας`,
  'ObjectStatus.cancelLoading.txt': () => `Ακύρωση φόρτωσης`,
  'ObjectStatus.loadingCanceled.txt': () => `Η φόρτωση ακυρώθηκε`,
  'ObjectStatus.resumeLoading.txt': () => `Συνέχιση φόρτωσης`,
  'ObjectStatus.refresh.txt': () => `Ανανέωση`,
  'ObjectStatus.setJobParameters.txt': () => `Ορισμός τιμών παραμέτρων`,
  'ObjectSearch.title.txt': () => `Γεωγραφική αναζήτηση`,
  'ObjectSearch.pin.txt': () => `Καρφίτσωμα`,
  'ObjectSearch.unpin.txt': () => `Ξεκαρφίτσωμα`,
  'MainSearchPanel.searchHints.txt': () => `Υποδείξεις αναζήτησης`,
  'MainSearchPanel.searchResults.txt': () => `Αποτελέσματα αναζήτησης`,
  'MainSearchPanel.features.txt': () => `Δυνατότητες`,
  'MainSearchPanel.pin.txt': () => `Νέο καρφίτσωμα`,
  'MainSearchPanel.pin.tooltip.txt': () => `Νέο καρφίτσωμα`,
  'MainSearchPanel.route.txt': () => `Νέα διαδρομή`,
  'MainSearchPanel.route.tooltip.txt': () => `Νέα διαδρομή`,
  'MainSearchPanel.geographicArea.txt': () => `Νέα γεωγραφική περιοχή`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Νέα γεωγραφική περιοχή`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Καρφίτσωμα της τοποθεσίας μου`,
  'MainSearchPanel.myLocationPin.txt': () => `Η τοποθεσία μου`,
  'MainSearchPanel.show.txt': () => `Εμφάνιση`,
  'MainSearchPanel.show.all.txt': () => `Εμφάνιση όλων`,
  'MainSearchPanel.hide.txt': () => `Απόκρυψη`,
  'MainSearchPanel.hide.all.txt': () => `Απόκρυψη όλων`,
  'MainSearchPanel.delete.txt': () => `Διαγραφή`,
  'MainSearchPanel.delete.all.txt': () => `Διαγραφή όλων`,
  'MainSearchPanel.convert.txt': () => `Μετατροπή αποτελεσμάτων αναζήτησης σε καρφιτσώματα`,
  'MainSearchPanel.convert.all.txt': () => `Μετατροπή όλων των αποτελεσμάτων αναζήτησης σε καρφιτσώματα`,
  'MainSearchPanel.showPinLabels.txt': () => `Εμφάνιση ετικετών καρφιτσωμάτων`,
  'MainSearchPanel.close.label.txt': () => `Γεωγραφική αναζήτηση`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Εμφάνιση λεπτομερειών`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Δημογραφικά στοιχεία`,
  'PanelHeader.back.tooltip.txt': () => `Πίσω`,
  'GeographicAreaPanel.title.txt': () => `Γεωγραφική περιοχή`,
  'GeographicAreaPanel.draw.txt': () => `Περιοχή σχεδίασης`,
  'GeographicAreaPanel.update.txt': () => `Περιοχή ενημέρωσης`,
  'GeographicAreaPanel.label.txt': () => `Ετικέτα:`,
  'GeographicAreaPanel.location.txt': () => `Τοποθεσία:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Απόσταση (μίλ.):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Απόσταση (χλμ.):`,
  'GeographicAreaPanel.distance.add.txt': () => `Προσθήκη απόστασης`,
  'GeographicAreaPanel.time.add.txt': () => `Προσθήκη ώρας`,
  'GeographicAreaPanel.distance.delete.txt': () => `Διαγραφή απόστασης`,
  'GeographicAreaPanel.time.minutes.txt': () => `Ώρα (λ.):`,
  'GeographicAreaPanel.duration.txt': () => `Διάρκεια:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Μίλια`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Χιλιόμετρα`,
  'GeographicAreaPanel.menu.clear.txt': () => `Απαλοιφή γεωγραφικής περιοχής`,
  'GeographicAreaPanel.menu.link.txt': () => `Διεύθυνση σύνδεσης σε στοιχεία δεδομένων και καρφιτσώματα από προεπιλογή`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Κατάργηση σύνδεσης γεωγραφικής περιοχής`,
  'GeographicAreaPanel.menu.delete.txt': () => `Διαγραφή γεωγραφικής περιοχής`,
  'GeographicAreaPanel.demographics.txt': () => `Δημογραφικά στοιχεία`,
  'GeographicAreaPanel.demographics.set.txt': () => `Εμφάνιση δημογραφικών στοιχείων`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Ανάπτυξη προβολής`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Επεξεργασία δημογραφικών στοιχείων`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Διαγραφή δημογραφικών στοιχείων`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Τα δημογραφικά στοιχεία πρέπει να επαναφορτωθούν`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Επαναφόρτωση δημογραφικών στοιχείων`,
  'GeographicAreaPanel.invalid.location.txt': () => `Η γεωγραφική περιοχή δεν έχει έγκυρη τοποθεσία και δεν μπορεί να δημιουργηθεί.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Επιλέξτε ημέρα και ώρα`,
  'TravelTypeField.cancel.txt': () => `Άκυρο`,
  'TravelTypeField.ok.txt': () => `OK`,
  'TravelTypeField.button.tooltip.txt': () => `Επιλέξτε ημέρα και ώρα`,
  'TravelTypeField.day.txt': () => `Ημέρα:`,
  'TravelTypeField.time.txt': () => `Ώρα:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Άμεση`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Απόσταση`,
  'TravelTypeField.travelType.txt': () => `Τύπος ταξιδιού:`,
  'TravelTypeField.traffic.txt': () => `Συμπερίληψη κίνησης:`,
  'TravelTypeField.traffic.offset.txt': () => `Χρονική μετατόπιση κίνησης:`,
  'TravelTypeField.traffic.daytime.txt': () => `Ημέρα και ώρα κίνησης:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Μονάδα απόστασης`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Απόσταση με αυτοκίνητο`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Χρόνος οδήγησης`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Απόσταση με φορτηγό`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Χρόνος με φορτηγό`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Απόσταση με τα πόδια`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Χρόνος με τα πόδια`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Όχι`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Τρέχουσα κίνηση`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Τυπική κίνηση`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} ώρ.`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Ενημέρωση κίνησης για αυτή τη δυνατότητα`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Ενημέρωση κίνησης για όλες τις δυνατότητες`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Ενημέρωση δεδομένων κίνησης`,
  'RoutePanel.title.txt': () => `Διαδρομή`,
  'RoutePanel.draw.txt': () => `Σχεδίαση διαδρομής`,
  'RoutePanel.update.txt': () => `Ενημέρωση διαδρομής`,
  'RoutePanel.label.txt': () => `Ετικέτα:`,
  'RoutePanel.locations.txt': () => `Τοποθεσίες`,
  'RoutePanel.menu.clear.txt': () => `Απαλοιφή διαδρομής`,
  'RoutePanel.menu.reverse.txt': () => `Αντιστροφή διαδρομής`,
  'RoutePanel.menu.add.waypoint.txt': () => `Προσθήκη τοποθεσίας διαδρομής`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Διαγραφή τοποθεσίας διαδρομής`,
  'RoutePanel.menu.unlink.txt': () => `Κατάργηση σύνδεσης τοποθεσίας διαδρομής`,
  'RoutePanel.menu.arrows.txt': () => `Βέλη διαδρομής`,
  'RoutePanel.menu.arrows.hide.txt': () => `Απόκρυψη βελών διαδρομής`,
  'RoutePanel.menu.arrows.show.txt': () => `Εμφάνιση βελών διαδρομής`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Μονή κατεύθυνση`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Διπλή κατεύθυνση`,
  'RoutePanel.menu.delete.txt': () => `Διαγραφή διαδρομής`,
  'RoutePanel.route.width.txt': () => `Πλάτος διαδρομής`,
  'RoutePanel.distance.txt': () => `Απόσταση:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} mi`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Προσθήκη τοποθεσίας`,
  'RoutePanel.location.delete.txt': () => `Διαγραφή τοποθεσίας`,
  'RoutePanel.duration.txt': () => `Ώρα:`,
  'RoutePanel.invalid.location.txt': () => `Η διαδρομή δεν έχει έγκυρες τοποθεσίες και δεν μπορεί να δημιουργηθεί.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Τοποθεσία ${index}, ${location}, είσοδος`,
  'PinPanel.pinTitle.txt': () => `Καρφίτσωμα`,
  'PinPanel.addDescription.txt': () => `Προσθήκη περιγραφής`,
  'PinPanel.deleteDescription.txt': () => `Διαγραφή περιγραφής`,
  'PinPanel.newPin.txt': () => `Νέο καρφίτσωμα σε αυτήν την τοποθεσία`,
  'PinPanel.deletePin.txt': () => `Διαγραφή καρφιτσώματος`,
  'PinPanel.linkPins.txt': () => `Σύνδεση καρφιτσωμάτων σε στοιχεία δεδομένων από προεπιλογή`,
  'PinPanel.unlinkAllItems.txt': () => `Κατάργηση σύνδεσης όλων των στοιχείων`,
  'PinPanel.unlinkItems.txt': () => `Κατάργηση σύνδεσης στοιχείων`,
  'PinPanel.label.txt': () => `Ετικέτα:`,
  'PinPanel.location.txt': () => `Τοποθεσία:`,
  'PinPanel.description.txt': () => `Περιγραφή:`,
  'PinPanel.linked.txt': () => `ΣΥΝΔΕΘΗΚΕ`,
  'PinPanel.searchClickPlaceholder.txt': () => `Αναζήτηση ή επιλογή στον χάρτη`,
  'PinPanel.searchPlaceholder.txt': () => `Αναζήτηση`,
  'PinPanel.addRoute.txt': () => `Προσθήκη διαδρομής`,
  'PinPanel.addRoute.tooltip.txt': () => `Προσθήκη διαδρομής`,
  'PinPanel.addArea.txt': () => `Προσθήκη γεωγραφικής περιοχής`,
  'PinPanel.addArea.tooltip.txt': () => `Προσθήκη γεωγραφικής περιοχής`,
  'PinPanel.addArea.title.txt': () => `Προσθήκη Γεωγραφικής Περιοχής`,
  'PinPanel.myLocationTitle.txt': () => `Καρφίτσωμα της Τοποθεσίας μου`,
  'PinPanel.deleteMyLocationPin.txt': () => `Διαγραφή Καρφιτσώματος της τοποθεσίας μου`,
  'PinPanel.enableAutoUpdate.txt': () => `Ενεργοποίηση αυτόματης ενημέρωσης της Τοποθεσίας μου`,
  'PinPanel.disableAutoUpdate.txt': () => `Απενεργοποίηση αυτόματης ενημέρωσης της Τοποθεσίας μου`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Επεξεργασία διαστήματος αυτόματης ενημέρωσης της Τοποθεσίας μου...`,
  'PinPanel.linkToPin.txt': () => `Σύνδεση σε καρφίτσωμα`,
  'PinPanel.useCurrentLocation.txt': () => `Χρήση τρέχουσας τοποθεσίας καρφιτσώματος`,
  'PinPanel.notDrawn.txt': () => `Χωρίς σχεδίαση`,
  'PinPanel.undetermined.txt': () => `Μη καθορισμένο`,
  'PinPanel.findMyLocation.txt': () => `Εύρεση της Τοποθεσίας μου`,
  'PinPanel.cannotDetermineLocation.txt': () => `Η εφαρμογή δεν μπορεί να προσδιορίσει την τρέχουσα τοποθεσία σας. Αν θέλετε να κοινοποιήσετε την τοποθεσία σας, ανατρέξτε στη βοήθεια για το πρόγραμμα περιήγησης ή τη συσκευή σας.`,
  'PinPanel.autoRefreshInterval.txt': () => `Διάστημα αυτόματης ενημέρωσης της Τοποθεσίας μου`,
  'PinPanel.interval.hours.txt': () => `Ώρες:`,
  'PinPanel.interval.minutes.txt': () => `Λεπτά:`,
  'PinPanel.interval.seconds.txt': () => `Δευτερόλεπτα:`,
  'PinPanel.invalid.location.txt': () => `Η καρφίτσα δεν έχει έγκυρη τοποθεσία και δεν μπορεί να δημιουργηθεί.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} mi`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} mi`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} mi`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}, ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}, ${value2}, ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} λ.`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} λ.`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} λ.`,
  'PinPanel.clearLocation.tooltip.txt': () => `Απαλοιφή κειμένου τοποθεσίας`,
  'DiscardChangesDialog.title.area.txt': () => `Γεωγραφική περιοχή`,
  'DiscardChangesDialog.title.route.txt': () => `Διαδρομή`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `Πραγματοποιήσατε αλλαγές στη γεωγραφική περιοχή αλλά δεν επανασχεδιάσατε την περιοχή.\n\nΘέλετε να απορρίψετε τις αλλαγές στο στοιχείο ${label};`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `Πραγματοποιήσατε αλλαγές στη γεωγραφική διαδρομή αλλά δεν επανασχεδιάσατε τη διαδρομή.\n\nΘέλετε να απορρίψετε τις αλλαγές στο στοιχείο ${label};`,
  'DiscardChangesDialog.discard.txt': () => `Απόρριψη`,
  'DiscardChangesDialog.cancel.txt': () => `Άκυρο`,
  'FeatureErrorDialog.title.area.txt': () => `Σχεδίαση γεωγραφικής περιοχής`,
  'FeatureErrorDialog.title.route.txt': () => `Σχεδίαση διαδρομής`,
  'FeatureErrorDialog.text.area.txt': () => `Δεν ήταν δυνατή η σχεδίαση της γεωγραφικής περιοχής.\n\nΣυμβουλή: Αν η τοποθεσία της περιοχής σας δεν περιέχει υποδομή ταξιδιών, όπως δρόμους, τότε μπορεί να μην είναι δυνατός ο υπολογισμός γεωγραφικής περιοχής. Χρησιμοποιήστε έναν τύπο απόστασης ταξιδιού ή μετακινήστε την περιοχή σε τοποθεσία με υποδομή ταξιδιών.`,
  'FeatureErrorDialog.text.route.txt': () => `Δεν ήταν δυνατή η σχεδίαση της διαδρομής.\n\nΣυμβουλή: Αν η τοποθεσία της διαδρομής σας δεν περιέχει υποδομή ταξιδιών, όπως δρόμους, τότε μπορεί να μην είναι δυνατός ο υπολογισμός διαδρομής. Χρησιμοποιήστε έναν τύπο απόστασης ταξιδιού ή μετακινήστε τη διαδρομή σε τοποθεσία με υποδομή ταξιδιών.`,
  'FeatureErrorDialog.close.txt': () => `Κλείσιμο`,
  'DemographicsSelectorDialog.title.txt': () => `Εμφάνιση δημογραφικών στοιχείων`,
  'DemographicsSelectorDialog.cancel.txt': () => `Άκυρο`,
  'DemographicsSelectorDialog.ok.txt': () => `OK`,
  'DemographicsSelectorDialog.country.txt': () => `Χώρα/περιοχή`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Βασικό`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Προηγμένη`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Πρόσφατα`,
  'DemographicsSelectorDialog.categories.txt': () => `Κατηγορίες`,
  'DemographicsSelectorDialog.category.income.txt': () => `Εισόδημα`,
  'DemographicsSelectorDialog.category.age.txt': () => `Ηλικία`,
  'DemographicsSelectorDialog.category.households.txt': () => `Οικογενειακές μονάδες`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Στέγαση`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Οικογενειακή κατάσταση`,
  'DemographicsSelectorDialog.category.population.txt': () => `Πληθυσμός`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Ομάδα χρηστών`,
  'DemographicsSelectorDialog.category.health.txt': () => `Υγεία`,
  'DemographicsSelectorDialog.category.education.txt': () => `Εκπαίδευση`,
  'DemographicsSelectorDialog.category.business.txt': () => `Επιχείρηση`,
  'DemographicsSelectorDialog.category.race.txt': () => `Φυλή`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Δαπάνες`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Συμπεριφορές`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Εργασίες`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Φτώχεια`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Πλέγμα`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `Σε κίνδυνο`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Βασικά γεγονότα`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Προσφορά και ζήτηση`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Πολιτική`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Οριζόντιος προσανατολισμός`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Έγκλημα`,
  'ManageColumns.title.txt': () => `Διαχείριση στηλών`,
  'ManageColumns.ok.txt': () => `OK`,
  'ManageColumns.cancel.txt': () => `Άκυρο`,
  'ManageColumns.hiddenColumns.txt': () => `Κρυφές στήλες`,
  'ManageColumns.displayedColumns.txt': () => `Εμφανιζόμενες στήλες`,
  'SearchResultPanel.title.txt': () => `Αποτέλεσμα αναζήτησης`,
  'SearchResultPanel.menu.delete.txt': () => `Διαγραφή αποτελέσματος αναζήτησης`,
  'SearchResultPanel.convert.txt': () => `Μετατροπή σε καρφίτσωμα`,
  'SearchResultPanel.convert.tooltip.txt': () => `Μετατροπή σε καρφίτσωμα`,
  'DemographicsResultsDialog.title.txt': () => `Δημογραφικά στοιχεία`,
  'DemographicsResultsDialog.cancel.txt': () => `Άκυρο`,
  'DemographicsResultsDialog.close.txt': () => `Κλείσιμο`,
  'DemographicsResultsDialog.edit.txt': () => `Επεξεργασία`,
  'DemographicsResultsDialog.layout.page.txt': () => `Προβολή καρουζέλ`,
  'DemographicsResultsDialog.layout.list.txt': () => `Προβολή μονής στήλης`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Προβολή πλακιδίων`,
  'DemographicsResultsDialog.noData.txt': () => `Δεν βρέθηκαν αντιστοιχίες δεδομένων για την τρέχουσα γεωγραφική περιοχή.`,
  'PinsAtSameLocationPanel.title.txt': () => `Καρφιτσώματα στην ίδια τοποθεσία`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `ΑΠΟΤΕΛΕΣΜΑΤΑ ΑΝΑΖΗΤΗΣΗΣ`,
  'PinsAtSameLocationPanel.pins.txt': () => `ΚΑΡΦΙΤΣΩΜΑΤΑ`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Εμφάνιση όλων`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Απόκρυψη όλων`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Διαγραφή όλων`,
  'PinsAtSameLocationPanel.show.txt': () => `Εμφάνιση`,
  'PinsAtSameLocationPanel.hide.txt': () => `Απόκρυψη`,
  'PinsAtSameLocationPanel.delete.txt': () => `Διαγραφή`,
  'LocationPopover.pin.title.txt': () => `Καρφίτσωμα τοποθεσίας`,
  'LocationPopover.area.title.txt': () => `Τοποθεσία γεωγραφικής περιοχής`,
  'LocationPopover.route.title.txt': ({label}) => `Τοποθεσία διαδρομής ${label}`,
  'LocationPopover.name.txt': () => `Όνομα`,
  'LocationPopover.location.txt': () => `Τοποθεσία:`,
  'LocationPopover.ok.txt': () => `Ορισμός τοποθεσίας`,
  'LocationPopover.cancel.txt': () => `Έξοδος από τη λειτουργία επιλογής`,
  'LocationPopover.hint.txt': () => `Κάντε κλικ ξανά στον χάρτη για αναγνώριση διαφορετικής τοποθεσίας.`,
  'TreeDualSelector.source.default.txt': () => `Διαθέσιμα στοιχεία`,
  'TreeDualSelector.target.default.txt': () => `Επιλεγμένα στοιχεία`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} από ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `Δεν υπάρχουν στοιχεία`,
  'TreeDualSelector.filter.placeholder.txt': () => `Φίλτρο`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Προσαρμοσμένο στοιχείο`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `Προστέθηκαν${noOfSelectedRows} στοιχεία`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `Καταργήθηκαν${noOfSelectedRows} στοιχεία`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Προστέθηκαν όλα τα στοιχεία`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Καταργήθηκαν όλα τα στοιχεία`,
  'TreeDualSelector.afterAction.up.txt': () => `Μετακινήθηκε επάνω`,
  'TreeDualSelector.afterAction.down.txt': () => `Μετακινήθηκε κάτω`,
  'TreeDualSelector.afterAction.top.txt': () => `Μετακινήθηκε στην κορυφή`,
  'TreeDualSelector.afterAction.bottom.txt': () => `Μετακινήθηκε στο κάτω μέρος`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Έγινε επαναφορά της ενέργειας προσθήκης`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Έγινε επαναφορά της ενέργειας κατάργησης`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `προσαρμοσμένο στοιχείο προστέθηκε`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} προσαρμοσμένο στοιχείο επιλέχθηκε`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} επιλεγμένα`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} επιλεγμένα`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Μετακίνηση μία σειρά επάνω σε ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Μετακίνηση μία σειρά κάτω σε ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `Μετακίνηση στην κορυφή του ${targetListLabel}`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `Μετακίνηση στο κάτω μέρος του ${targetListLabel}`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Προσθήκη στοιχείου σε ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Προσθήκη όλων σε ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Κατάργηση στοιχείου από ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Κατάργηση όλων από ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Αναίρεση προσθήκης για ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Αναίρεση κατάργησης για ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `Φίλτρο ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Κατάργηση`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Τυχόν προσαρμοσμένα στοιχεία που έχετε επιλέξει για κατάργηση θα διαγραφούν οριστικά εάν συνεχίσετε.\n\n Θέλετε να συνεχίσετε;`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Κατάργηση όλων των στοιχείων`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `Τα προσαρμοσμένα στοιχεία σε αυτήν τη λίστα θα διαγραφούν οριστικά εάν συνεχίσετε.\n\n Θέλετε να συνεχίσετε;`,
  'LinkNavigator.backButton.label': () => `Πίσω`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Φίλτρα εισερχομένων`,
  'LinkNavigator.reportLevel.label': () => `Επίπεδο αναφοράς`,
  'LinkNavigator.sectionLevel.label': () => `Επίπεδο σελίδας`,
  'ReportSectionZeroState.heading.label': () => `Σχεδίαση αναφοράς`,
  'ReportSectionZeroState.description.label': () => `Σύρετε αντικείμενα ή στοιχεία δεδομένων στη σελίδα ή ορίστε μια επιλογή παρακάτω.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Σύρετε αντικείμενα ή στοιχεία δεδομένων στη σελίδα ή ξεκινήστε από ένα πρότυπο σελίδας.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Δημιουργία αντικειμένου`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Επιλέξτε ένα πρότυπο`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Εξερεύνηση προτάσεων`,
  'PromptContainerTooltip.noSelections.txt': () => `Δεν υπάρχουν επιλογές`,
  'PromptContainerTooltip.selectedValues.txt': () => `Επιλεγμένες τιμές`,
}
export default localizers;
